var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Crop = function Crop(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 14 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M10.5 10.5H4.812A1.314 1.314 0 0 1 3.5 9.187V3.5h5.688c1.312 0 1.312.659 1.312.875V10.5zm.875 0V4.375c0-1.095-.818-1.75-2.188-1.75H3.5V0h-.875v2.625H0V3.5h2.625v5.688a2.19 2.19 0 0 0 2.188 2.187H10.5V14h.875v-2.625H14V10.5h-2.625z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Crop;
//# sourceMappingURL=Crop.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Crop.js